import './grid_tile.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import _includes from 'lodash/includes';

import GridTileWrapperUi from './grid_tile_wrapper.ui.jsx';

import {
  TILE_HOVER_CLASSNAMES_BY_TYPE,
  TILE_HOVER_BACKGROUND_COLOR_CLASSNAME,
  TILE_HOVER_TEXT_COLOR_CLASSNAME,
  CAPTION_RIGHT_CLASSNAME,
  CAPTION_LEFT_CLASSNAME,
} from 'zoomforth_codesbane_viewer/const/css_wiki_classnames.js';


const reduceFraction = function(numerator, denominator){
  var gcd = function gcd(a,b){
    return b ? gcd(b, a%b) : a;
  };
  gcd = gcd(numerator,denominator);
  return [numerator/gcd, denominator/gcd];
};



class GridTileWrapper extends Component {
  
  constructor(props) {
    super(props);

    this.tileWrapperNodeRef = null; // this will be the ref of the main wrapping tile element
  }

  componentDidMount() {
    this.doPostRender();
  }
  
  componentDidUpdate() {
    this.doPostRender();
  }
  
  doPostRender() {
    this.props.setUpTileForLayout(this.tileWrapperNodeRef);
  }


  render() {
    const {
      uuid,
      actionTypeName,
      itemType,
      htmlContent,
      shouldCaptionBeUnderneath,
      shouldMaintainStackOrder,
      shouldShowHover,
      sizex,
      sizey,
      className,
      stylePresetClassName,
      cssClassesList,
      captionData,
      hoverEffectType,
      hoverBackgroundColor,
      hoverTextColor,
      row,
      col,
      contentId,
      hasFileIcon,
      verticalAlign,
      horizontalAlign,
      outerTileWrapperStyle,
      middleTileWrapperStyle,
      children,
      onOverlayOpen,
      onMouseEnter,
      onMouseLeave
    } = this.props;
    
    const shouldRenderTileCaption = (
      !_includes(['link','form','text','html_package','iframe_embed'], itemType) &&
      htmlContent
    );
    // In mobile layout for certain sizes for exmaple, maybe render the caption *underneath* the tile;
    // this prevents the tile caption from completely covering the rest of the tile
    const shouldRenderCaptionUnderneath = ( 
      shouldRenderTileCaption &&
      shouldCaptionBeUnderneath
    );
    
    const sizeFraction = reduceFraction(sizex, sizey);
    const dataTileAspectReducedAttr = `${sizeFraction[0]}x${sizeFraction[1]}`;

    const hoverEffectClassName = TILE_HOVER_CLASSNAMES_BY_TYPE[hoverEffectType];

    const {
      orientation: captionOrientation,
    } = captionData;

    const wrapperClassNames = classNames(
      'tile-wrapper',
      `type-${itemType}`,
      stylePresetClassName,
      cssClassesList,
      className,
      hoverEffectClassName,
      {
        [TILE_HOVER_BACKGROUND_COLOR_CLASSNAME]: !!hoverBackgroundColor,
        [TILE_HOVER_TEXT_COLOR_CLASSNAME]: !!hoverTextColor,
        [CAPTION_RIGHT_CLASSNAME]: captionOrientation === 'right',
        [CAPTION_LEFT_CLASSNAME]: captionOrientation === 'left',
      },
    );

    return (
      <GridTileWrapperUi 
        tellRef={(ref) => {
          this.tileWrapperNodeRef = ref;
        }}
        actionTypeName={actionTypeName}
        className={wrapperClassNames}
        contentId={contentId}
        data-col={col}
        data-row={row}
        data-sizex={sizex}
        data-sizey={sizey}
        shouldShowHover={shouldShowHover}
        dataTileAspectReducedAttr={dataTileAspectReducedAttr}
        hasFileIcon={hasFileIcon}
        horizontalAlign={horizontalAlign}
        outerTileWrapperStyle={outerTileWrapperStyle}
        itemType={itemType}
        uuid={uuid} 
        verticalAlign={verticalAlign}
        shouldMaintainStackOrder={shouldMaintainStackOrder}
        onOverlayOpen={onOverlayOpen}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div 
          className={classNames('tile-padding-wrapper', {'push-caption-underneath': shouldRenderCaptionUnderneath})}
          style={middleTileWrapperStyle}
        >

          { children }

        </div>
      </GridTileWrapperUi>
    );
  }
}

GridTileWrapper.defaultProps = {
  shouldCaptionBeUnderneath: false
};

GridTileWrapper.propTypes = {
  uuid: PropTypes.number.isRequired,
  contentId: PropTypes.number.isRequired,
  pageId: PropTypes.number.isRequired,
  actionTypeName: PropTypes.string.isRequired,
  actionData: PropTypes.any,
  horizontalAlign: PropTypes.string,
  verticalAlign: PropTypes.string,
  htmlContent: PropTypes.string,
  fontSize: PropTypes.number,
  stylePresetClassName: PropTypes.string,
  cssClassesList: PropTypes.array,
  linkTitle: PropTypes.string,
  linkSource: PropTypes.string,
  linkDescription: PropTypes.string,
  middleTileWrapperStyle: PropTypes.object.isRequired,
  outerTileWrapperStyle: PropTypes.object.isRequired,
  hasFileIcon: PropTypes.bool.isRequired,
  itemType: PropTypes.string.isRequired,
  sizex: PropTypes.number.isRequired,
  sizey: PropTypes.number.isRequired,
  row: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  col: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  shouldCaptionBeUnderneath: PropTypes.bool,
  setUpTileForLayout: PropTypes.func.isRequired,
  shouldMaintainStackOrder: PropTypes.bool
};

export default GridTileWrapper;
